import DefaultLayout from "../layouts/DefaultLayout";
import { useNavigation } from "@react-navigation/native";
import CustomText from "../components/common/general/CustomText/CustomText.js";
import CustomButton from "../components/common/general/CustomButton/CustomButton.js";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";

function AdminView() {
  const navigation = useNavigation();

  const handleAdminPress = () => {
    navigation.navigate("Tenant Dashboard");
  };

  const handleOAuthPress = () => {
    navigation.navigate("OAuth Client Dashboard");
  };

  return (
    <DefaultLayout pageHasChat={false}>
      <CustomText
        role="header"
        text="Dashboard"
        size="l"
        textType="display"
        weight="ultraBold"
        useTranslationText={false}
      />
      <CustomSpacing size="large" />
      <CustomButton text="Tenant Dashboard" onPress={handleAdminPress} useTranslationText={false} />
      <CustomSpacing size="m" />
      <CustomButton text="OAuth Clients" onPress={handleOAuthPress} useTranslationText={false} />
    </DefaultLayout>
  );
}

export default AdminView;
